import { render, staticRenderFns } from "./DeviceGenericVehicle.vue?vue&type=template&id=d518b23e&scoped=true&"
import script from "./DeviceGenericVehicle.vue?vue&type=script&lang=js&"
export * from "./DeviceGenericVehicle.vue?vue&type=script&lang=js&"
import style0 from "./DeviceGenericVehicle.vue?vue&type=style&index=0&id=d518b23e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d518b23e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d518b23e')) {
      api.createRecord('d518b23e', component.options)
    } else {
      api.reload('d518b23e', component.options)
    }
    module.hot.accept("./DeviceGenericVehicle.vue?vue&type=template&id=d518b23e&scoped=true&", function () {
      api.rerender('d518b23e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/device_types/DeviceGenericVehicle.vue"
export default component.exports